import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';

const CustomFieldsPage = () => {
    return (
        <PageLayout title='커스텀필드' actionButton={<NewButton onClick={() => { }} >커스텀필드추가</NewButton>}    >
            {/* 커스텀 필드 관련 컨텐츠 */}
        </PageLayout>
    );
};

export default CustomFieldsPage;